// Simple, bulletproof slideshow that WILL work
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, initializing slideshows...');
  
  // Find all slideshow components
  const slideshows = document.querySelectorAll('slideshow-component');
  console.log(`Found ${slideshows.length} slideshow(s)`);
  
  slideshows.forEach(slideshow => {
    initSlideshow(slideshow);
  });
});

function initSlideshow(component) {
  const sectionId = component.dataset.sectionId;
  const autoplayEnabled = component.dataset.autoplay === 'true';
  const autoplaySpeed = parseInt(component.dataset.speed) * 1000;
  
  console.log(`Initializing slideshow ${sectionId}`, {
    autoplay: autoplayEnabled,
    speed: autoplaySpeed
  });
  
  const slides = Array.from(component.querySelectorAll('.slideshow__slide'));
  
  if (slides.length <= 1) {
    console.log('Not enough slides, skipping');
    return;
  }
  
  let currentSlide = 0;
  let autoplayTimer = null;
  let isAutoplaying = autoplayEnabled;
  let isPausedByUser = false;
  
  // Set up initial state
  updateSlides();
  
  // Navigation buttons
  const prevButton = component.querySelector('.slider-button--prev');
  const nextButton = component.querySelector('.slider-button--next');
  
  // Force enable buttons (remove disabled attribute that might be set by other scripts)
  if (prevButton) {
    prevButton.removeAttribute('disabled');
    prevButton.addEventListener('click', () => {
      console.log('Previous clicked');
      goToPrevSlide();
    });
  }
  
  if (nextButton) {
    nextButton.removeAttribute('disabled'); // Force enable the right button
    nextButton.addEventListener('click', () => {
      console.log('Next clicked');
      goToNextSlide();
    });
  }
  
  // Pagination buttons
  const paginationButtons = component.querySelectorAll('.slider-counter__link');
  paginationButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      console.log(`Pagination ${index} clicked`);
      goToSlide(index);
    });
  });
  
  // Autoplay button
  const autoplayButton = component.querySelector('.slideshow__autoplay');
  if (autoplayButton) {
    setupAutoplayButton();
    
    autoplayButton.addEventListener('click', () => {
      console.log('Autoplay button clicked');
      toggleAutoplay();
    });
  }
  
  // Start autoplay if enabled
  if (autoplayEnabled) {
    console.log('Starting autoplay');
    startAutoplay();
  }
  
  // Pause on hover
  component.addEventListener('mouseenter', () => {
    if (isAutoplaying && !isPausedByUser) {
      pauseAutoplay();
    }
  });
  
  component.addEventListener('mouseleave', () => {
    if (isAutoplaying && !isPausedByUser) {
      startAutoplay();
    }
  });
  
  function goToSlide(index) {
    if (index < 0 || index >= slides.length || index === currentSlide) {
      return;
    }
    
    console.log(`Going to slide ${index}`);
    currentSlide = index;
    updateSlides();
    updatePagination();
    updateCounter();
    
    if (isAutoplaying && !isPausedByUser) {
      startAutoplay();
    }
  }
  
  function goToNextSlide() {
    const nextIndex = (currentSlide + 1) % slides.length;
    goToSlide(nextIndex);
  }
  
  function goToPrevSlide() {
    const prevIndex = currentSlide === 0 ? slides.length - 1 : currentSlide - 1;
    goToSlide(prevIndex);
  }
  
  function updateSlides() {
    slides.forEach((slide, index) => {
      if (index === currentSlide) {
        slide.setAttribute('aria-current', 'true');
        slide.removeAttribute('tabindex');
      } else {
        slide.removeAttribute('aria-current');
        slide.setAttribute('tabindex', '-1');
      }
    });
  }
  
  function updatePagination() {
    paginationButtons.forEach((button, index) => {
      const isActive = index === currentSlide;
      button.setAttribute('aria-selected', isActive.toString());
      button.setAttribute('tabindex', isActive ? '0' : '-1');
      
      if (isActive) {
        button.classList.add('slider-counter__link--active');
      } else {
        button.classList.remove('slider-counter__link--active');
      }
    });
  }
  
  function updateCounter() {
    const currentCounter = component.querySelector('.slider-counter--current');
    if (currentCounter) {
      currentCounter.textContent = (currentSlide + 1).toString();
    }
  }
  
  function setupAutoplayButton() {
    if (isAutoplaying) {
      autoplayButton.setAttribute('aria-pressed', 'true');
      autoplayButton.setAttribute('aria-label', 'Pause slideshow');
      autoplayButton.classList.remove('slideshow__autoplay--paused');
    } else {
      autoplayButton.setAttribute('aria-pressed', 'false');
      autoplayButton.setAttribute('aria-label', 'Play slideshow');
      autoplayButton.classList.add('slideshow__autoplay--paused');
    }
  }
  
  function startAutoplay() {
    if (!isAutoplaying || slides.length <= 1) return;
    
    clearTimeout(autoplayTimer);
    autoplayTimer = setTimeout(() => {
      console.log('Autoplay advancing slide');
      goToNextSlide();
    }, autoplaySpeed);
  }
  
  function pauseAutoplay() {
    clearTimeout(autoplayTimer);
  }
  
  function toggleAutoplay() {
    if (isAutoplaying) {
      console.log('Pausing autoplay');
      isAutoplaying = false;
      isPausedByUser = true;
      pauseAutoplay();
    } else {
      console.log('Starting autoplay');
      isAutoplaying = true;
      isPausedByUser = false;
      startAutoplay();
    }
    setupAutoplayButton();
  }
  
  // Handle page visibility changes
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      pauseAutoplay();
    } else if (isAutoplaying && !isPausedByUser) {
      startAutoplay();
    }
  });
}

// DEBUG: Test both arrows specifically
setTimeout(() => {
  const leftBtn = document.querySelector('.slider-button--prev');
  const rightBtn = document.querySelector('.slider-button--next');
  
  console.log('Left button found:', !!leftBtn);
  console.log('Right button found:', !!rightBtn);
  
  if (leftBtn) {
    console.log('Left button HTML:', leftBtn.outerHTML);
  }
  
  if (rightBtn) {
    console.log('Right button HTML:', rightBtn.outerHTML);
    
    // Force add a click listener to test
    rightBtn.addEventListener('click', function(e) {
      console.log('RIGHT BUTTON FORCE CLICKED!');
      e.preventDefault();
      e.stopPropagation();
    });
    
    // Test if something is covering it
    const rect = rightBtn.getBoundingClientRect();
    const elementAtPoint = document.elementFromPoint(rect.left + rect.width/2, rect.top + rect.height/2);
    console.log('Element at right button center:', elementAtPoint);
    console.log('Is it the button itself?', elementAtPoint === rightBtn);
    
    // Force enable the button again (in case something keeps disabling it)
    rightBtn.removeAttribute('disabled');
    console.log('Forced right button enabled');
  }
}, 3000);